import { render, staticRenderFns } from "./Materi1.vue?vue&type=template&id=f34b8f06&"
import script from "./Materi1.vue?vue&type=script&lang=js&"
export * from "./Materi1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports